export default __webpack_public_path__ + "i18n/sv.bca42c022c06bef3c775b396629d3715.json";